export const ACTION_GET_AVAILABLE_LUCKY_DRAW = '/Coupon/GetLuckyDraw';

export const ACTION_GET_NUMBER_SPIN_EMAIL = '/Coupon/GetNumberOfSpinByEmail';

export const ACTION_APPLY_REWARD = '/Coupon/ApplyRewardToEmail';

export const ACTION_GET_MY_PRIZE_LUCKY_DRAW = '/coupon/GetMyPrizes';

export const ACTION_GET_CHANCE_TO_WIN = '/coupon/GetChanceToWin';
